import * as Sentry from '@sentry/react';
import { SENTRY_DSN, TRACES_SAMPLE_RATE } from './constants/config';
import Router from './router/Router';
import { Layout } from './components/ui/layout';
import { ThemeProvider } from './providers/theme-provider';
import type { CSSProperties } from 'react';
import { Toaster } from 'sonner';

if (SENTRY_DSN) {
  Sentry.init({
    ignoreErrors: ['Breaking for redirection. Nevermind'],
    dsn: SENTRY_DSN,
    tracesSampleRate: parseFloat(TRACES_SAMPLE_RATE ?? ''),
  });
}

/**
 * Close (X) on the toast's top-right corner instead of Sonner's default top-left — the left corner
 * overhangs whatever is beside the toast, typically a page's primary buttons.
 */
const TOASTER_CLOSE_BUTTON_RIGHT = {
  '--toast-close-button-start': 'unset',
  '--toast-close-button-end': '0',
  '--toast-close-button-transform': 'translate(35%, -35%)',
} as CSSProperties;

const App = () => (
  <ThemeProvider defaultTheme="light">
    <Layout>
      <Router />
    </Layout>
    {/* `pointer-events-auto`: an open Radix dialog sets `pointer-events: none` on the body, which
        would otherwise make a toast raised from inside that dialog unclickable — including its
        close button. Pairs with the toaster guard in components/ui/dialog.tsx. */}
    <Toaster
      position="top-right"
      richColors
      closeButton
      className="pointer-events-auto"
      style={TOASTER_CLOSE_BUTTON_RIGHT}
    />
  </ThemeProvider>
);

export default App;
